const allInvestorDetailsReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_ALL_INVESTOR_DETAILS":
          return state;
      case "SET_ALL_INVESTOR_DETAILS" :
          return action.info;
      case "NULL_ALL_INVESTOR_DETAILS" :
          return action.info;
      default:
          return state;
    }
  }
  export default allInvestorDetailsReducer
